import React from "react";
import { useFormikContext } from "formik";
import { List } from "react-virtualized";

import { Loader } from "@ui/loader/loader";
import { TokensTableRow } from "./tokens-table-row";
import { toast } from "react-toastify";

import { CreateFundFormType } from "@/pages/create-fund/types";
import { Token } from "@/pages/create-fund/components/select-tokens/select-tokens";

interface Props {
  tokenList: Token[];
  isLoading: boolean;
}

export const TokensTable = ({ tokenList, isLoading }: Props) => {
  const { setValues, values } = useFormikContext<CreateFundFormType>();

  const handleSelect = (token: Token) => {
    if (typeof token.token_price_lovelace !== "number") {
      toast.error(
        "Price for token not available, you can't add this token to the fund.",
      );
      return;
    }

    const tokenId = token.token_id || token.policy_id;
    const newTokenIds = [
      ...new Set([...values.selectedTokenIds, tokenId]),
    ];
    const count = newTokenIds.length;
    const base = Math.floor(100 / count);
    const factors = Array(count).fill(base);
    let rest = 100 - base * count;
    for (let i = 0; rest > 0; i++, rest--) {
      factors[i] += 1;
    }

    const newTokens = Object.fromEntries(
      newTokenIds.map((id, i) => {
        if (values.selectedTokens[id]) {
          return [
            id,
            { ...values.selectedTokens[id], distribution: factors[i] },
          ];
        }

        return [
          id,
          {
            ...token,
            distribution: factors[i],
            token_price_lovelace: token.token_price_lovelace ?? null,
          },
        ];
      }),
    );

    setValues({
      ...values,
      selectedTokenIds: newTokenIds,
      selectedTokens: newTokens,
    });
  };

  return (
    <>
      {isLoading ? (
        <div className="w-full h-full py-[258px]">
          <Loader />
        </div>
      ) : (
        <List
          width={1000}
          height={546}
          rowCount={tokenList.length}
          rowHeight={76}
          overscanRowCount={5}
          // style={{ width: "100%" }}
          // containerStyle={{ width: "100%" }}
          autoContainerWidth
          autoWidth
          rowRenderer={({ key, index, style }) => (
            <TokensTableRow
              style={style}
              key={key}
              token={tokenList[index]}
              handleSelect={handleSelect}
            />
          )}
        />
      )}
    </>
  );
};
